import { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
// import usaFlag from '../../assets/imgs/usa.png'
import usaFlag from '../../assets/imgs/us2.png'
// import brasilFlag from '../../assets/imgs/brazil.png'
import brasilFlag from '../../assets/imgs/br2.png'
import { useTranslation } from 'react-i18next'
import { I18N_MANUAL_STORAGE_KEY, I18N_STORAGE_KEY } from '../../i18n/index'
import espanhaFlag from '../../assets/imgs/espanha.png'
import { Globe, ChevronDown } from '../../assets/svgs/icons'
import { putUserAccountLang } from '../../services/userAccounts'

const languageOptions = [
  {
    name: 'Português',
    value: 'ptBR',
    flag: brasilFlag,
  },
  {
    name: 'English',
    value: 'en',
    flag: usaFlag,
  },
  {
    name: 'Espanhol',
    value: 'es',
    flag: espanhaFlag,
  },
]

function LanguageSwitcher({
  dropdown = false,
  compact = false,
  ghost = false,
  small = false,
  iconColor = '#414141',
  menuPlacement = 'bottom',
  dropdownAlign = 'end',
}) {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const wrapperRef = useRef(null)

  const currentLanguage =
    languageOptions.find((opt) => opt.value === i18n.language) ||
    languageOptions[0]

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    if (dropdown) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [dropdown])

  const persistLanguage = (value) => {
    i18n.changeLanguage(value)
    localStorage.setItem(I18N_STORAGE_KEY, value)
    localStorage.setItem(I18N_MANUAL_STORAGE_KEY, 'true')

    // Persist to backend only when the user is authenticated
    const token = window.localStorage.getItem('token')
    if (token) {
      putUserAccountLang(value).catch(() => {
        // Silently ignore — UI already reflects the change via localStorage
      })
    }
  }

  const handleSelect = (value) => {
    persistLanguage(value)
    setIsOpen(false)
  }


  if (!dropdown) {
    return (
      <div className={styles.box_country_flag}>
        {languageOptions.map((languageOption, index) => (
          <div
            key={index}
            className={styles.country_flag}
            onClick={() => persistLanguage(languageOption.value)}
          >
            <img
              src={languageOption.flag}
              alt={languageOption.name}
            />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={styles.dropdownWrapper} ref={wrapperRef}>
      <button
        className={`${styles.languageTrigger} ${compact ? styles.languageTriggerCompact : ''} ${ghost ? styles.languageTriggerGhost : ''} ${small ? styles.languageTriggerSmall : ''} ${isOpen ? styles.languageTriggerOpen : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-label="Language"
      >
        <Globe width={small ? 18 : 20} height={small ? 18 : 20} color={iconColor} />
        {!compact && (
          <span className={styles.languageArrow}>
            <ChevronDown
              size={14}
              color={isOpen ? '#9002CD' : '#414141'}
            />
          </span>
        )}
      </button>

      {isOpen && (
        <div
          className={`${styles.languageDropdown} ${menuPlacement === 'top' ? styles.languageDropdownTop : ''} ${dropdownAlign === 'start' ? styles.languageDropdownAlignStart : ''} ${dropdownAlign === 'outside' ? styles.languageDropdownAlignOutside : ''}`}
        >
          <div
            className={`${styles.dropdownArrow} ${menuPlacement === 'top' ? styles.dropdownArrowTop : ''} ${dropdownAlign === 'start' || dropdownAlign === 'outside' ? styles.dropdownArrowAlignStart : ''}`}
          />
          {languageOptions.map((option) => (
            <button
              key={option.value}
              className={`${styles.languageDropdownItem} ${currentLanguage.value === option.value ? styles.languageDropdownItemActive : ''}`}
              onClick={() => handleSelect(option.value)}
              type="button"
            >
              <img
                src={option.flag}
                alt={option.name}
                className={styles.dropdownFlag}
              />
              <span className={styles.dropdownLabel}>{option.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSwitcher
